import type { CatalogTree } from '../types';

export const ai = {
  tabs: {
    label: 'Asistan bölümleri',
    status: 'Durum',
    knowledge: 'Bilgi',
    handoff: 'Personele aktarma',
    voice: 'Ses',
    gaps: 'Boşluklar',
    testChat: 'Deneme sohbeti',
    usage: 'Kullanım',
  },
  save: 'Kaydet',
  status: {
    flavor: {
      whatsapp: 'WhatsApp',
      instagram: 'Instagram',
    },
    modeLabel: '{channel} {name}',
    pause: {
      title: 'Tümünü duraklat',
      hint: 'Duraklatılınca asistan hiçbir kanalda yeni konuşma almaz; süren konuşmalar personelde kalır.',
    },
    replyHours: {
      title: 'Ne zaman yanıtlasın',
      always: 'Her zaman',
      outside_staff_hours: 'Yalnızca mesai dışında',
      after_staff_delay: 'Personel {n} dakika içinde yanıtlamazsa',
      delay: 'Bekleme (dk)',
    },
    empty: 'Henüz bağlı kanal yok.',
    emptyAction: 'Entegrasyonlar',
  },
  knowledge: {
    policies: 'Politikalar',
    policy: {
      address_hours: 'Adres ve çalışma saatleri',
      shipping: 'Kargo',
      delivery_time: 'Teslimat süresi',
      cash_on_delivery: 'Kapıda ödeme',
      payment_methods: 'Ödeme yöntemleri',
      instalments: 'Taksit',
      returns_exchanges: 'İade ve değişim',
      certificates_invoices: 'Sertifika ve fatura',
      pickup: 'Mağazadan teslim',
      custom_orders: 'Özel sipariş',
    },
    packDefault: 'Varsayılan metin',
    reset: 'Varsayılana dön',
    updated: 'Güncellendi: {time}',
    faq: 'Sık sorulan sorular',
    question: 'Soru',
    answer: 'Cevap',
    moveUp: 'Yukarı taşı',
    moveDown: 'Aşağı taşı',
    remove: 'Kaldır',
    addQuestion: 'Soru ekle',
    payment: 'Ödeme bilgileri',
    ibanText: 'IBAN metni',
    paymentLink: 'Ödeme bağlantısı',
    sharing: {
      label: 'Asistan paylaşabilir',
      off: 'Paylaşmasın',
      iban: 'Yalnızca IBAN',
      link: 'Yalnızca bağlantı',
      both: 'İkisini de',
      note: 'Asistan bunları yalnızca müşteri sipariş özetini onayladıktan sonra paylaşır; ödemeyi hiçbir zaman kendisi almaz.',
    },
    priceRules: 'Fiyat kuralları',
    cardPrice: {
      label: 'Kart fiyatı',
      platform: 'Mağazadaki fiyatlar',
      percent_over_transfer: 'Havale fiyatının üzerine yüzde',
      none: 'Tek fiyat, ödeme yöntemi söylenmez',
      percent: 'Yüzde',
      rounding: 'Yuvarlama',
      roundingOption: {
        none: 'Yok',
        whole_tl: 'Tam TL',
        ten_tl: '10 TL',
      },
    },
    freshness: 'Fiyat tazelik sınırı (dk)',
    freshnessHint: 'Bu süreden eski bir fiyat müşteriye söylenmez; personele aktarılır.',
  },
  handoff: {
    topics: 'Personele giden konular',
    alwaysHint: 'Asistan bu durumda her zaman personele aktarır.',
    hours: 'Çalışma saatleri',
    alwaysAvailable: 'Personel her zaman ulaşılabilir',
    holidays: 'Tatil günleri',
    closed: 'Kapalı',
    range: '{from}–{to}',
    replies: 'Aktarma mesajları',
    inHours: 'Mesai içinde',
    outOfHours: 'Mesai dışında',
    notify: 'Kim bildirim alsın',
    notifyMode: {
      all_staff: 'Tüm personel',
      assignee_only: 'Yalnızca atanan kişi',
      selected: 'Seçili kişiler',
    },
    people: 'Kişiler',
    timers: 'Süreler',
    timer: {
      resume_ai_after_h: 'Personel sessiz kalırsa asistana dönüş (saat)',
      inactivity_close_h: 'Hareketsiz konuşmayı kapat (saat)',
      window_warning_min: 'Yanıt süresi dolmadan uyar (dk)',
      waiting_alert_min: 'Bekleyen konuşma uyarısı (dk)',
    },
  },
  voice: {
    identity: 'Kimlik',
    name: 'Asistanın adı',
    signature: 'İmza',
    greeting: 'Karşılama',
    formality: {
      label: 'Üslup',
      formal: 'Resmi ("efendim")',
      warm: 'Samimi',
    },
    disclosure: 'Yapay zekâ açıklaması',
    disclosureEnabled: 'İlk yanıtta açıklama yap',
    disclosureText: 'Açıklama cümlesi',
    preview: 'Önizleme',
    banned: 'Yasaklı ifadeler',
    newPhrase: 'Yeni ifade',
    bannedNote: 'Asistan bu ifadeleri içeren bir yanıtı göndermez; konuşma personele aktarılır.',
    suggestions: 'Ürün önerileri',
    maxCards: 'En fazla kart',
    similar: 'Benzer model önerileri',
    similarHint: 'Kapalıyken katalogda birebir bulunmayan fotoğraflar personele aktarılır.',
  },
  gaps: {
    table: 'Cevaplanamayan sorular',
    question: 'Soru',
    topic: 'Konu',
    noTopic: 'Konusuz',
    count: 'Kaç kez',
    firstAsked: 'İlk soruluş',
    lastAsked: 'Son soruluş',
    statusColumn: 'Durum',
    status: {
      open: 'Açık',
      answered: 'Cevaplandı',
      ignored: 'Yoksayıldı',
    },
    statusFilter: 'Durum',
    topicFilter: 'Konu',
    allTopics: 'Tüm konular',
    answer: 'Cevap ekle',
    ignore: 'Yoksay',
    reopen: 'Yeniden aç',
    ownerOnly: 'Cevabı işletme sahibi ekleyebilir.',
    empty: 'Cevaplanamayan soru yok.',
  },
  testChat: {
    flavor: 'Kanal',
    restart: 'Yeni sohbet',
    note: 'Deneme sohbetleri raporlara, satışlara ve kullanıma sayılmaz ve personele bildirim göndermez.',
    unavailable: 'Deneme sohbeti bu ortamda kullanılamıyor.',
    presets: 'Hazır mesajlar',
    storyReply: 'Hikâyeye yanıt ver',
    storyText: 'Bu ürün hâlâ var mı?',
    handedOff: 'Personele aktarıldı: {reason}',
    empty: 'Asistana bir müşteri gibi yazın.',
  },
  usage: {
    period: 'Bu dönem',
    range: '{start} – {end}',
    source: {
      subscription: 'Abonelik dönemi',
      calendar_month: 'Takvim ayı',
    },
    units: 'Kullanım',
    allowance: 'Hak',
    unlimited: 'Sınırsız',
    percent: '%{percent}',
    meter: 'Kullanım oranı',
    over: 'Sınır aşıldı',
    limit: {
      continue_and_prompt: 'Asistan yanıtlamaya devam ediyor; planınızı yükseltebilirsiniz.',
      staff_only: 'Asistan bu dönem yalnızca personele aktarıyor.',
    },
    threshold: '%{percent} eşiği aşıldı: {time}',
    count: {
      reply_turn: 'Yanıt turu',
      draft_turn: 'Taslak turu',
      image_match: 'Görsel eşleme',
    },
    billing: 'Plan ve ödeme',
    trend: 'Son 6 dönem',
    trendPeriod: 'Dönem',
    empty: 'Henüz kullanım yok.',
  },
} as const satisfies CatalogTree;
